import { createAsyncThunk } from "@reduxjs/toolkit";
import { AuthState, AuthLoginProps, AuthResponseProps, AuthRegisterProps, UniqueCheckProps, AuthForgotPasswordProps, AuthResetPasswordProps, BillingSignatureProps } from "./types";
import axios from "axios";

export const AuthLogin = createAsyncThunk(
  "auth/login",
  async (props: AuthLoginProps) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/auth/signin`,
        {
          username: props.username,
          password: props.password,
        }
      );

      if (response && response.data) {
        if (response.data.data.roles?.includes("ROLE_AFFILIATOR")) {
          return {
            data: "Affiliator not allowed",
            status: "error",
            error: null,
          } as unknown as AuthState;
        }
        const merchants = response?.data?.data.merchants || [];
        return {
          data: {
            ...response.data,
            data: {
              ...response.data.data,
              isAuthenticated: true,
              merchants: merchants,
            },
          } as AuthResponseProps,
          status: "success",
          error: null,
        } as unknown as AuthState;
      } else {
        return {
          data: "Wrong username or password",
          status: "error",
          error: null,
        } as unknown as AuthState;
      }
    } catch (err: any) {
      return {
        data: err.response?.data || "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as AuthState;
    }
  }
);

export const AuthLogout = createAsyncThunk("auth/logout", async () => {
  return {
    data: "Logged out!",
    status: "error",
    error: null,
  } as unknown as AuthState;
});

export const switchMerchant = createAsyncThunk(
  "auth/switchMerchant",
  async (merchantId: number, { getState }) => {
    try {
      const state: any = getState();
      const currentAuth = state.Auth.data;

      if (currentAuth?.data?.merchants) {
        const newMerchant = currentAuth.data.merchants.find(
          (m: any) => m.id === merchantId
        );

        console.log("newMErchant is: ",newMerchant);
        if (newMerchant) {
          return {
            data: {
              ...currentAuth,
              data: {
                ...currentAuth.data,
                merchant: newMerchant,
              },
            },
            status: "success",
            error: null,
          };
        }
      }

      return {
        data: currentAuth,
        status: "error",
        error: "Merchant not found",
      };
    } catch (err) {
      return {
        data: null,
        status: "error",
        error: err,
      };
    }
  }
);

export const AuthRegisterMerchant = createAsyncThunk(
  "auth/registerMerchant",
  async (props: AuthRegisterProps) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NEST_API_URL}/api/v1/auth/register`,
        props
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as AuthState;
      } else {
        return {
          data: "Registration failed",
          status: "error",
          error: null,
        } as unknown as AuthState;
      }
    } catch (err) {
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as AuthState;
    }
  }
);

export const UniqueUsernameNMailCheck = createAsyncThunk(
  "auth/uniqueUsernameNMailCheck",
  async (props: UniqueCheckProps) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NEST_API_URL}/api/v1/auth/check-unique`,
        props
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as AuthState;
      } else {
        return {
          data: "Check failed",
          status: "error",
          error: null,
        } as unknown as AuthState;
      }
    } catch (err) {
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as AuthState;
    }
  }
)

//notes: nanti ganti pakai token bukan pakai email
export const AuthVerifyEmail = createAsyncThunk(
  "auth/verifyEmail",
  async (email: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NEST_API_URL}/api/v1/auth/verify?email=${email}`
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as AuthState;
      } else {
        return {
          data: "Email verification failed",
          status: "error",
          error: null,
        } as unknown as AuthState;
      }
    } catch (err) {
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as AuthState;
    }
  }
)

export const AuthForgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (props: AuthForgotPasswordProps) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/auth/forgot-password`,
        props
      );
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as AuthState;
      } else {
        return {
          data: "Failed",
          status: "error",
          error: null,
        } as unknown as AuthState;
      }
    } catch (err: any) {
      return {
        data: err.response?.data?.metaData?.message || "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as AuthState;
    }
  }
);

export const AuthResetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (props: AuthResetPasswordProps) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/auth/reset-password`,
        props
      );
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as AuthState;
      } else {
        return {
          data: "Failed",
          status: "error",
          error: null,
        } as unknown as AuthState;
      }
    } catch (err: any) {
      return {
        data: err.response?.data?.metaData?.message || "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as AuthState;
    }
  }
);

export const GetBillingSignature = createAsyncThunk(
  "auth/getBillingSignature",
  async (props: BillingSignatureProps) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NEST_API_URL}/api/v1/auth/billing-signature`,
        props
      );
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        };
      } else {
        return {
          data: null,
          status: "error",
          error: "Failed to generate billing signature",
        };
      }
    } catch (err: any) {
      return {
        data: null,
        status: "error",
        error: err.response?.data?.message || err.message || "Something went wrong while generating signature!",
      };
    }
  }
);